import React, { useMemo } from "react";
import { Checkbox, Input, Form, Grid } from "antd";
import DynamicInputFields from "./DynamicInputFields";

// CheckListFBYInput Component
// This component renders a checklist with checkboxes and an optional input field for each checkbox.
// Props:
// - options: An array of objects representing the checkboxes.
// - initialValues: An object containing the initial values for the checkboxes.
// Usage: <CheckListFBYInput options={checkboxOptions} initialValues={initialValues} />

const CheckListFBYInput = ({
  options,
  checkboxes,
  setCheckboxes,
  form,
  field_key,
  keyChain = null,
  others_key = null,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  // Tablet + mobile: keep remarks fields full-width so the remove (-) fits beside the input
  const isCompactWidth = !screens.xl;

  const checkboxesData = options || [];
  const nestedWatch = Form.useWatch(keyChain, form);
  const rootWatch = Form.useWatch([], form);

  const effectiveCheckboxes = useMemo(() => {
    const result = { ...(checkboxes || {}) };

    checkboxesData.forEach((checkbox) => {
      const formVal = keyChain
        ? nestedWatch?.[checkbox.value]
        : rootWatch?.[checkbox.value];

      if (formVal !== undefined && formVal !== null) {
        result[checkbox.value] = !!formVal;
      }
    });

    return result;
  }, [checkboxes, checkboxesData, keyChain, nestedWatch, rootWatch]);

  const handleCheckboxChange = (value, event) => {
    const nextChecked =
      event?.target?.checked ?? !effectiveCheckboxes?.[value];

    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [value]: nextChecked,
    }));

    // When unchecking, clear any dependent fields so stale data doesn't reappear.
    if (!nextChecked && form?.setFieldValue) {
      if (others_key && value === others_key) {
        // Clear DynamicInputFields (others list)
        form.setFieldValue(field_key, []);
      } else {
        // Clear description textbox for this option
        const descName = keyChain
          ? [keyChain, `${value}_description`]
          : `${value}_description`;
        form.setFieldValue(descName, "");
      }
    }
  };

  // console.log(checkboxesData, checkboxes);

  return (
    // <Row>
    <>
      {checkboxesData.map((checkbox, index) => (
        // <Col span={8} key={index}>
        <>
          <Form.Item
            name={keyChain ? [keyChain, checkbox.value] : checkbox.value}
            valuePropName="checked"
            // style={{ marginBottom: "-6px" }}
          >
            <Checkbox onChange={(e) => handleCheckboxChange(checkbox.value, e)}>
              {checkbox.label}
            </Checkbox>
          </Form.Item>
          {/* Render an input field if the checkbox is checked */}
          {effectiveCheckboxes[checkbox.value] &&
            (others_key ? checkbox.value !== others_key : true) && (
              <Form.Item
                style={{
                   maxWidth: isCompactWidth ? "100%" : 800,
                   marginLeft: isCompactWidth ? 0 : 20,
                   marginRight: isCompactWidth ? 0 : 20,
                 }}
                name={
                  keyChain
                    ? [keyChain, `${checkbox.value}_description`]
                    : `${checkbox.value}_description`
                }
              >
                <Input.TextArea
                  rows={isMobile ? 1 : 2}
                  placeholder="Enter Details"
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                  }}
                />
              </Form.Item>
            )}
          {checkbox.value === others_key && effectiveCheckboxes[others_key] && (
            <DynamicInputFields
              field_key={field_key}
              form={form}
              inputStyle={{
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
              }}
              formStyle={{
                width: "100%",
                maxWidth: isCompactWidth ? "100%" : 800,
                marginRight: isCompactWidth ? 0 : 20,
                marginLeft: isCompactWidth ? 0 : 20,
              }}
            />
          )}
        </>
        // </Col>
      ))}
    </>
    // </Row>
  );
};

export default CheckListFBYInput;
